require('../../modules/es6.object.is-sealed');
module.exports = require('../../modules/_core').Object.isSealed;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/object/is-sealed.js
// module id = 54
// module chunks = 0